var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7071 2.25202V0.383057H14.4308V2.25202H12.4283V3.4197H14.4308V5.31165H15.7071V3.4197H17.709V2.25202H15.7071ZM11.1772 1.90166V0.733417H1.86764C1.43399 0.733417 1.06281 0.877485 0.754093 1.16562C0.445375 1.45376 0.291016 1.80019 0.291016 2.20493V15.1453C0.291016 15.55 0.445375 15.8965 0.754093 16.1846C1.06281 16.4727 1.43399 16.6168 1.86764 16.6168H15.7569C16.1906 16.6168 16.5576 16.4727 16.8579 16.1846C17.1582 15.8965 17.3083 15.55 17.3083 15.1453V6.47933H16.0573V15.1453C16.0573 15.2387 16.028 15.3127 15.9696 15.3673C15.9111 15.4215 15.8402 15.4486 15.7569 15.4486H1.86764C1.76754 15.4486 1.69246 15.4215 1.64241 15.3673C1.59236 15.3127 1.56733 15.2387 1.56733 15.1453V6.47933V4.61093V2.20493C1.56733 2.1115 1.59236 2.03769 1.64241 1.9835C1.69246 1.92894 1.76754 1.90166 1.86764 1.90166H11.1772ZM3.54457 13.0896H14.1305L10.9268 9.09554L8.02398 12.5756L5.97167 10.1466L3.54457 13.0896Z",
    fill: "#85CDDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesIcon);
export default __webpack_public_path__ + "static/media/images_icon.f41c51eb0a5f8324cccb9bb9781aed05.svg";
export { ForwardRef as ReactComponent };